import React from 'react';
import { FileSearch, Database } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../redux/store';
import {
  selectDocumentSearchUserQuery,
  selectDocumentSearchKnowledgebases
} from '../../redux/selectors/documentSearchSelectors';
import { getLanguageDirection } from '../../i18n/config';

const DocumentSearchHeader: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isRTL = getLanguageDirection(i18n.language) === 'rtl';

  const userQuery = useAppSelector(selectDocumentSearchUserQuery);
  const knowledgebases = useAppSelector(selectDocumentSearchKnowledgebases);

  if (!userQuery) return null;

  return (
    <div className="rounded-xl border-2 border-gold/20 bg-gold/5 p-4">
      {/* Title */}
      <div className="flex items-center gap-2 mb-3">
        <FileSearch size={18} className="text-gold" />
        <span className="text-xs font-black text-gold uppercase tracking-widest">
          {t('components.documentSearch.searchedIn', 'Document Search')}
        </span>
      </div>

      {/* Query */}
      <p
        dir={isRTL ? 'rtl' : 'ltr'}
        className="text-sm font-medium text-foreground leading-relaxed mb-3"
      >
        {userQuery.content}
      </p>

      {/* Knowledgebases */}
      {knowledgebases.length > 0 && (
        <div>
          <div className="flex items-center gap-1.5 mb-1.5">
            <Database size={12} className="text-muted-foreground" />
            <span className="text-[10px] font-black text-muted-foreground uppercase tracking-widest">
              {t('components.documentSearch.selectKnowledgebases', 'Knowledgebases')}
            </span>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {knowledgebases.map((kb) => (
              <span
                key={kb._id}
                className="inline-flex items-center px-2.5 py-0.5 rounded-md bg-gold/10 text-gold text-xs font-semibold"
              >
                {kb.name}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentSearchHeader;
